var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-terms-condition"},[_c('vx-spinner',{ref:"spinner",attrs:{"image":_vm.globals.assetsPath+'images/spinner.gif',"full-screen":""}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.termsConditionData)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8abca176","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-terms-condition/vx-terms-condition.html
// module id = null
// module chunks = 